import { Team__Adrianes } from "../teams/Adrianes";
import { Team__Cerveceros_2 } from "../teams/Cerveceros_2";
import { Team__Joeles } from "../teams/Joeles";
import { Team__Llamas } from "../teams/Llamas";
import { Team__Lorenas } from "../teams/Lorenas";
import { Team__LosQuintanas } from "../teams/LosQuintanas";
import { Team__Natalias } from "../teams/Natalias";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Potros } from "../teams/Potros";
import { Team__Pythons } from "../teams/Pythons";
import { Team__RoadRunner } from "../teams/RoadRunner";
import { Team__RWE } from "../teams/RWE";
import { Team__Wolfpack } from "../teams/Wolfpack";

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_2,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 39,
  penaltyGoals: 0,
  isWinner: false,
};

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 49,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 46,
  penaltyGoals: 0,
  isWinner: false,
};

const Lorenas = {
  team: Team__Lorenas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const LosQuintanas = {
  team: Team__LosQuintanas,
  playingPlayers: [],

  goals: 25,
  penaltyGoals: 0,
  isWinner: false,
};

const LosQuintanas_Match2 = {
  team: Team__LosQuintanas,
  playingPlayers: [],

  goals: 48,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const RoadRunner = {
  team: Team__RoadRunner,
  playingPlayers: [],

  goals: 20,
  penaltyGoals: 0,
  isWinner: false,
};

const RWE = {
  team: Team__RWE,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

const Wolfpack = {
  team: Team__Wolfpack,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [
    {
      team1: Llamas,
      team2: Wolfpack,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2025-07-31",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Natalias,
      team2: LosQuintanas,

      isCompleted: true,
      isPlaying: true,
      day: "Jueves",
      date: "2025-07-31",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },

    {
      team1: RoadRunner,
      team2: Joeles,

      isCompleted: true,
      isPlaying: true,
      day: "Jueves",
      date: "2025-07-31",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: RWE,
      team2: LosQuintanas_Match2,

      isCompleted: true,
      isPlaying: true,
      day: "Jueves",
      date: "2025-07-31",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },

    {
      team1: Adrianes,
      team2: PecanBros,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2025-07-31",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
